import { getSessionSignup } from '@/views/Signup/session';
import store from '@/store';

import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback
} from '../middleware.interface';
import MerchantService from '../../api/MerchantService';
import { app } from '@/main';

export class LoadProvidersList implements IRouterMiddleware {
  private merchantService = new MerchantService();
  private routes = new Set([
    'welcome',
    'new-onboarding',
    'bo-select-business',
    'bo-choose-loyalty-reward',
    'bo-your-store'
  ]);

  canActivate(to: MiddlewareRoute, from: MiddlewareRoute): boolean {
    return to.name ? this.routes.has(to.name) : false;
  }

  async execute(
    to: MiddlewareRoute,
    from: MiddlewareRoute,
    next: MiddlewareCallback
  ): Promise<void> {
    if ((app.$store.getters['merchant/getProvidersList'] || []).length > 0) {
      next();
      return;
    }
    const country = getSessionSignup().country;

    const response = await this.merchantService.listProviders({
      params: { country }
    });

    const providers = response.data.providers;

    await store.dispatch('merchant/SET_PROVIDERS_LIST', providers);

    next();
  }
}
